import { formatDistanceToNow } from 'date-fns';

/**
 * Single source of truth for post-state + pillar display labels and the
 * relative-time formatter (ADR-0029). Previously duplicated — with drift —
 * across Dashboard, Posts, ProjectDetail, Inbox, and PostDetail.
 */
export const STATE_LABEL = {
  draft: 'Draft',
  rendered: 'Rendered',
  review: 'In Review',
  approved: 'Approved',
  publishing: 'Publishing…',
  published: 'Published',
  engagement_ingested: 'Stats in',
  analyzed: 'Analyzed',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

export const PILLAR_LABEL = {
  pain_point: 'Pain point',
  tip: 'Tip',
  product_showcase: 'Product',
  reel: 'Reel',
  story: 'Story',
};

export function pillarLabel(key) {
  return PILLAR_LABEL[key] || (key || '').replace(/_/g, ' ');
}

export function fmtAgo(iso) {
  try { return formatDistanceToNow(new Date(iso), { addSuffix: true }); }
  catch { return iso || '—'; }
}

/**
 * Render an account handle with exactly one leading '@'.
 *
 * Adapters disagree on storage: Instagram/Facebook store a bare name, X and
 * TikTok store it already '@'-prefixed, LinkedIn stores a Page display name.
 * Callers that prepend '@' therefore produced "@@clilancers". Normalize at
 * render time so no migration is needed and future adapters can't reintroduce it.
 */
export function atHandle(handle) {
  const h = String(handle || '').replace(/^@+/, '').trim();
  return h ? `@${h}` : '';
}
